import DgKanban from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgKanban.install = function (Vue) {
  Vue.component(DgKanban.name, DgKanban)
}
export default DgKanban

export { DgKanban }